import { cn } from "../lib/cn";

export interface CountBadgeProps {
  count: number;
  /** Past this, shows "9+". */
  max?: number;
  className?: string;
}

/** An unread count: a 16px attention-red circle with the number in micro white (DESIGN.md,
 * "Unread counts"). */
export function CountBadge({ count, max = 9, className }: CountBadgeProps) {
  if (count <= 0) return null;
  return (
    <span
      aria-hidden
      className={cn(
        "inline-flex h-4 min-w-4 shrink-0 items-center justify-center rounded-pill bg-attention px-1 font-medium text-[11px] text-on-attention leading-none tnum",
        className,
      )}
    >
      {count > max ? `${max}+` : count}
    </span>
  );
}
